import { FEATURE_FLAGS, useLaunchDarklyFlags } from "shared-services";
import { useGetAboutMe } from "pages/Profile/hooks/useGetAboutMe";
import { useGetCredits } from "pages/Profile/hooks/useGetCredits";
import { useGetBasicInfo } from "pages/Profile/hooks/useGetBasicInfo";
import { useGetGallery } from "pages/Profile/hooks/useGetGallery";
import useGetReps from "pages/Profile/hooks/useGetReps";
import { useGetSkills } from "pages/Profile/hooks/useGetSkills";
import { useGetSocialMedia } from "pages/Profile/components/SocialMediaSection/hooks/useGetSocialMedia";
import { useGetProfileSocialMediaWebsite } from "pages/Profile/hooks/useGetProfileSocialMediaWebsite";
import { useGetTraining } from "pages/Profile/hooks/useGetTraining";

export function usePrintDataIsReady() {
  const isInstagramIntegrationEnabled = useLaunchDarklyFlags(
    FEATURE_FLAGS.InstagramIntegration
  );
  const { isLoading: aboutMeIsLoading } = useGetAboutMe();
  const { isLoading: creditsIsLoading } = useGetCredits();
  const { isLoading: basicInfoIsLoading } = useGetBasicInfo();
  const { isLoading: galleryIsLoading } = useGetGallery();
  const { isLoading: repsIsLoading } = useGetReps();
  const { isLoading: skillsIsLoading } = useGetSkills();
  const { isLoading: socialMediaIsLoading } = useGetSocialMedia(
    isInstagramIntegrationEnabled
  );
  const { isLoading: websiteIsLoading } = useGetProfileSocialMediaWebsite();
  const { isLoading: trainingIsLoading } = useGetTraining();

  return [
    aboutMeIsLoading,
    websiteIsLoading,
    creditsIsLoading,
    basicInfoIsLoading,
    galleryIsLoading,
    repsIsLoading,
    socialMediaIsLoading,
    skillsIsLoading,
    trainingIsLoading,
  ].every((item) => !item);
}
